class Statistiques {
	constructor() {
		this.section = document.querySelector("section.statistiques");
		this.elementVisible = false;

		if (!this.section) {
			return;
		}

		this.init();
	}

	init() {
		var observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.gestionAnimationNumbers();
					observer.unobserve(entry.target);
				}
			});
		});
		observer.observe(this.section);
	}

	gestionAnimationNumbers() {
		var nb = document.querySelectorAll("section.statistiques .statistiques__item").length;

		if (nb > 0) {
			var countTo1 = document.getElementById("animateCount-1");
			var nb1 = countTo1.getAttribute("counto");
			var duration1 = countTo1.getAttribute("duration");
			if (duration1 == null) {
				duration1 = 1500;
			}
			this.animateValue("animateCount-1", 0, nb1, parseInt(duration1));
		}

		if (nb > 1) {
			var countTo2 = document.getElementById("animateCount-2");
			var nb2 = countTo2.getAttribute("counto");
			var duration2 = countTo2.getAttribute("duration");
			if (duration2 == null) {
				duration2 = 1500;
			}
			this.animateValue("animateCount-2", 0, nb2, parseInt(duration2));
		}

		if (nb > 2) {
			var countTo3 = document.getElementById("animateCount-3");
			var nb3 = countTo3.getAttribute("counto");
			var duration3 = countTo3.getAttribute("duration");
			if (duration3 == null) {
				duration3 = 1500;
			}
			this.animateValue("animateCount-3", 0, nb3, parseInt(duration3));
		}

		if (nb > 3) {
			var countTo4 = document.getElementById("animateCount-4");
			var nb4 = countTo4.getAttribute("counto");
			var duration4 = countTo4.getAttribute("duration");
			if (duration4 == null) {
				duration4 = 1500;
			}
			this.animateValue("animateCount-4", 0, nb4, parseInt(duration4));
		}
	}

	animateValue(id, start, end, duration) {
		// assumes integer values for start and end

		var obj = document.getElementById(id);
		var range = end - start;
		// no timer shorter than 50ms (not really visible any way)
		var minTimer = 50;
		// calc step time to show all interediate values
		var stepTime = Math.abs(Math.floor(duration / range));

		// never go below minTimer
		stepTime = Math.max(stepTime, minTimer);

		// get current time and calculate desired end time
		var startTime = new Date().getTime();
		var endTime = startTime + duration;
		var timer;

		function run() {
			var now = new Date().getTime();
			var remaining = Math.max((endTime - now) / duration, 0);
			var value = Math.round(end - remaining * range);
			obj.innerHTML = value;
			if (value == end) {
				clearInterval(timer);
			}
		}

		timer = setInterval(run, stepTime);
		run();
	}
}
